export const FONT_CONSTANT ={
    regular: 'Poppins-Regular',
    medium:'Poppins-Medium',
    semiBold:'Poppins-semiBold',
    bold:'Poppins-Bold'
}